export const getErrorCode = error => {
  return error && error.response && error.response.status
}
